/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons";
import { colors } from "../../../constants/colors";
import { useSpinnersContext } from "../../../contexts/spinnersContext";

/* Styles */
import styles from "./styles.js"


const Footer = props => {
  const { setShowModal, handleSaveModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const spinner = useSpinnersContext();

  return (
    <ContainerFluid className="gx-0">
      <Row>
        <Col className={classes.cancelBtnCol}>
          <UCButton
            onClick={() => setShowModal(false)}
            type="default"
            className={classes.cancelBtn}
            text={<FormattedMessage id="peopleGrid.deleteAction.cancel"/>}
          />
        </Col>
        <Col className={classes.saveBtnCol}>
          <UCButton
            className={classes.saveBtn}
            onClick={handleSaveModal}
            type="primary"
            text={<FormattedMessage id="peopleGrid.updateTeamAction.change"/>}
            spinner={{
              name: "updatePeopleSpinner",
              size: 20,
            }}
          />
        </Col>
      </Row>
    </ContainerFluid>
  )
}

export default Footer;
